var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shijian-wrapper",style:({width:_vm.width*0.29+'px'})},[_c('div',{staticClass:"shijian-head"},[_vm._v("事件办理")]),_c('div',{attrs:{"id":"chart_example"}})])}
var staticRenderFns = []

export { render, staticRenderFns }